import { z } from 'zod'

/**
 * What keeps a HoneyBook-managed event from following its project
 * (docs/honeybook.plan.md, phase 4). Mirrors the `HoneyBookEventProblem` enum in
 * the Prisma schema (`check:enums`).
 *
 * - `unreadable` — HoneyBook no longer shows the project to the connection.
 * - `deleted` — HoneyBook says the project was deleted.
 * - `no_date` — the project lost its date; the event keeps its last one.
 * - `phase_outside` — HoneyBook changed the times and a plan falls outside them.
 */
export const HONEYBOOK_EVENT_PROBLEMS = ['unreadable', 'deleted', 'no_date', 'phase_outside'] as const

export const honeybookEventProblemSchema = z.enum(HONEYBOOK_EVENT_PROBLEMS)

export type HoneyBookEventProblem = z.infer<typeof honeybookEventProblemSchema>

/** What each problem says on the event and in the venue's HoneyBook settings. */
export const HONEYBOOK_EVENT_PROBLEM_COPY: Readonly<Record<HoneyBookEventProblem, string>> = {
  unreadable: 'HoneyBook no longer shows this event’s project.',
  deleted: 'This event’s project was deleted in HoneyBook.',
  no_date: 'HoneyBook’s project has no date any more, so this event keeps its last one.',
  phase_outside: 'HoneyBook changed the times, and a plan falls outside them.',
}
